import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "./AuthContext";

const BillingContext = createContext(null);

export const BillingProvider = ({ children }) => {
    const { user } = useAuth();
    const [billing, setBilling] = useState(null);
    const [prenovaConn, setPrenovaConn] = useState(null);

    const refresh = useCallback(async () => {
        if (!user) return;
        try {
            const { data } = await api.get("/billing/status");
            setBilling(data);
        } catch (_e) { /* */ }
        try {
            const { data } = await api.get("/prenova/connection-status");
            setPrenovaConn(data);
        } catch (_e) { /* */ }
    }, [user]);

    useEffect(() => {
        refresh();
        if (!user) return;
        const id = setInterval(refresh, 30000);
        return () => clearInterval(id);
    }, [user, refresh]);

    return (
        <BillingContext.Provider value={{ billing, prenovaConn, refresh }}>
            {children}
        </BillingContext.Provider>
    );
};

export const useBilling = () => useContext(BillingContext);
